<template lang="pug">
v-container(fluid class="tw-w-full tw-mx-auto")
  v-row(justify="center")
    v-col(cols="auto" class="tw-text-center")
      span(class="h2") Simple, transparent pricing
      p(class="text-secondary h4 tw-pt-4") Kubiqa Pro is free during Early Access. No credit card required.
  v-row(justify="center" class="tw-pt-4")
    v-col(cols="12" sm="10" md="7" lg="5")
      v-card(outlined elevation="3" class="tw-p-6 tw-rounded-lg")
        v-chip(color="indigo lighten-5" text-color="indigo darken-3" class="tw-font-bold") EARLY ACCESS
        div(class="tw-pt-5")
          div(class="tw-font-bold tw-uppercase tw-text-blueGray-darken-1 tw-text-xl") {{ pro.name }}
          div(class="tw-pt-3")
            span(class="tw-text-4xl tw-font-black") €{{ pro.monthlyPriceEuros }}
            span(class="tw-text-blueGray-lighten-3 tw-text-lg") /month
          div(class="tw-pt-3 tw-font-bold tw-text-green-darken-2") €{{ pro.earlyAccessPriceEuros }} during Early Access
          p(class="text-secondary tw-pt-2") Founding users receive preferential pricing when paid plans launch.
        v-divider(class="tw-my-4")
        div(v-for="feature in pro.features" :key="feature" class="tw-pb-2")
          v-img(src="@/assets/images/web/check-icon.svg" width="10px" height="10px" class="d-inline-flex tw-mr-2")
          span(class="tw-text-blueGray-lighten-2") {{ feature }}
        p(class="text-secondary tw-pt-4 tw-mb-1") No credit card required.
        v-btn(block large color="#2f53c9" class="tw-mt-3 tw-rounded-md" @click="captureProIntent")
          span(class="tw-capitalize tw-font-semibold") Join Early Access
</template>

<script>
import { EARLY_ACCESS_PRO, EARLY_ACCESS_REGISTRATION_ROUTE } from '@/config/earlyAccess';
import { trackEarlyAccessEvent } from '@/services/AnalyticsService';

export default {
  name: 'EarlyAccessPricing',
  data() {
    return { pro: EARLY_ACCESS_PRO };
  },
  mounted() {
    trackEarlyAccessEvent(this, 'pricing_viewed', { plan: 'kubiqa_pro' });
  },
  methods: {
    captureProIntent() {
      trackEarlyAccessEvent(this, 'pricing_plan_intent', { plan: 'kubiqa_pro' });
      this.$router.push(EARLY_ACCESS_REGISTRATION_ROUTE);
    },
  },
};
</script>
